import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon } from '@hz-design-system/web-ui';

import Classes from './BundleFeature.module.scss';

const LabelNewFeature = () => {
  const i18n = useI18nContext();

  return <span className={Classes.newLabel}>- {i18n.t('purchaseBundle.labelNewFeature')}</span>;
};

const BundleFeature = ({ text, isDisabled, isNew }: { text: string; isDisabled: boolean; isNew: boolean }) => {
  const iconSvg = isDisabled ? 'close' : 'checkmark-circle';
  const textDisabledClassName = isDisabled ? Classes['text--disabled'] : '';

  return (
    <div className={Classes.root}>
      <Icon name={iconSvg} className={Classes.icon} />
      <div className={`${Classes.text} ${textDisabledClassName}`}>
        {text}
        {isNew && <LabelNewFeature />}
      </div>
    </div>
  );
};

export default BundleFeature;
